import { Controller } from "@hotwired/stimulus"

// Ensures all links within note content open in new tabs
export default class extends Controller {
  connect() {
    this.makeLinksExternal()
  }

  // Called when new content is added via Turbo Streams
  elementUpdated() {
    this.makeLinksExternal()
  }

  makeLinksExternal() {
    // Find all links within this controller's element (note content areas)
    const links = this.element.querySelectorAll('a')
    
    links.forEach(link => {
      // Only modify links that don't already have a target
      if (!link.hasAttribute('target')) {
        link.setAttribute('target', '_blank')
        link.setAttribute('rel', 'noopener noreferrer')
      }
    })
  }
} 